import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import { FUNNEL_CHART_DATA } from "@/api/queries/funnelChartData";
import { processFunnelData } from "@/pages/ZeemeeFunnel/utils";
import { FunnelBarData } from "../Funnel/types";
import { HalfFunnelChart, Tab } from "./HalfFunnelChart";
import { useOrg } from "@/hooks/useOrg";
import { useNow } from "@/hooks/useNow";
import { getDateString } from "@/util/dateUtils";
import { FilterState } from "../FilterSidebar/FilterState";
import { useCurrentCohortYear } from "@/hooks/useCurrentCohortYear";

export const HalfFunnelChartContainer = () => {
  const { org } = useOrg();
  const { cohortYear } = useCurrentCohortYear();
  const now = useNow();
  const date = new Date(now);
  const { data, loading } = useQuery(FUNNEL_CHART_DATA, {
    variables: {
      orgId: org?.id || "",
      filters: new FilterState({
        cohortYear: [`${cohortYear}`],
      }).getQueryFilter(),
      date: getDateString(date),
    },
    skip: !org?.id || !cohortYear,
  });
  const [tab, setTab] = useState<Tab>("inCommunity");

  let inCommunityData: FunnelBarData[] = [];
  let notInCommunityData: FunnelBarData[] = [];

  const node = data?.node;
  if (node?.__typename === "Organization") {
    inCommunityData = processFunnelData(
      node?.funnelChartData?.inCommunity || [],
      true,
    );
    notInCommunityData = processFunnelData(
      node?.funnelChartData?.notInCommunity || [],
      true,
    );
  }

  return (
    <HalfFunnelChart
      loading={loading}
      inCommunityRows={inCommunityData}
      notInCommunityRows={notInCommunityData}
      tab={tab}
      onChangeTab={setTab}
      actualDataDate={date}
    />
  );
};
